import {TDDFilterExpressionDto} from 'features/predicate-expression-form-list';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {IGetDataArgs} from '../model/types';
import {IRiskDocumentsResponse, IPostRiskDocumentsArgs, IDeleteRiskDocumentsArgs} from './types';

const RISK_CODES_ROUTE = 'ais3.spv.risk.codes';
const RISKS_DOCUMENTS_ROUTE = 'svc-risk-codes-docs-mapping';

const getData = (args?: IGetDataArgs) =>
    performRequest<IRiskDocumentsResponse>({
        url: RISK_CODES_ROUTE,
        method: ERequestType.GET,
        params: {paginationPageSize: args?.paginationPageSize, paginationCurrent: args?.paginationCurrent, organizationId: args?.organizationId?.id},
    });

const getRuleDataByRiskId = (id: number) =>
    performRequest<TDDFilterExpressionDto>({
        url: `${RISK_CODES_ROUTE}/${RISKS_DOCUMENTS_ROUTE}/${id}`,
        method: ERequestType.GET,
    });    

const postData = (args: IPostRiskDocumentsArgs) =>
    performRequest<string>({url: `${RISK_CODES_ROUTE}/${RISKS_DOCUMENTS_ROUTE}/${args?.riskCode}`, data: args?.values, method: ERequestType.POST});

const deleteData = (args: IDeleteRiskDocumentsArgs) =>
    performRequest<string>({
        url: `${RISK_CODES_ROUTE}/${RISKS_DOCUMENTS_ROUTE}/rpc/delete-list`,
        data: {ids: args.rowsIds},
        method: ERequestType.DELETE,
    });

export const RisksDocumentsApi = {getData, getRuleDataByRiskId, postData, deleteData};
